export default function getMagnitude(n) {
  if (n === 0) {
    return 1;
  }
  return Math.max(0, Math.floor(Math.log10(Math.abs(n))) + 1);
}
